<template>
	<v-container grid-list-xs fluid fill-height>
		<v-layout column>
			<v-flex shrink>
				<v-toolbar flat class="elevation-0 transparent">
					<v-toolbar-title>Bertha Jobs</v-toolbar-title>
				</v-toolbar>
			</v-flex>

			<v-flex overflow-hidden>
				<v-data-table
					:headers="headers"
					:items="jobs"
					:pagination.sync="pagination"
					:loading="loading"
					:total-items="totalElements"
					:rows-per-page-items="[10]"
				>
					<template v-slot:items="props">
						<td>{{ props.item.id }}</td>
						<td>{{ props.item.action }}</td>
						<td>{{ props.item.userId }}</td>
						<td>{{ props.item.startTime | moment }}</td>
						<td>{{ props.item.durationInSeconds }}</td>
						<td :class="`${aiActionsStatusColorMap[props.item.status]}--text`">{{ props.item.status }}</td>
						<td>
							<job-actions-menu v-if="canShowJobActionsMenu(props.item.status)" :job="props.item"></job-actions-menu>
						</td>
					</template>
				</v-data-table>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { STORE_USER_NAME, STATE_TOKEN } from '@/store_constants/user';
import AIService, { aiActionsStatus, aiActionsStatusColorMap } from '@/services/AIService';
import JobActionsMenu from './components/JobActionsMenu.vue';

export default {
	name: 'BerthaJobs',
	components: {
		JobActionsMenu
	},
	filters: {
		moment(date) {
			return moment(date).format('LLL');
		}
	},
	data() {
		return {
			aiActionsStatusColorMap,
			loading: false,
			headers: [
				{
					text: 'Job ID',
					value: 'id',
					sortable: false
				},
				{
					text: 'Action',
					value: 'action',
					sortable: false
				},
				{
					text: 'User',
					value: 'userId',
					sortable: false
				},
				{
					text: 'Start Time',
					value: 'startTime',
					sortable: false
				},
				{
					text: 'Duration (s)',
					value: 'durationInSeconds',
					sortable: false
				},
				{
					text: 'Status',
					value: 'status',
					sortable: false
				},
				{
					text: '',
					value: '',
					sortable: false
				}
			],
			jobs: [],
			pagination: {
				page: 1,
				rowsPerPage: 50
			},
			totalElements: 0,
			totalPages: 0,
			aiService: null
		};
	},
	async created() {
		this.aiService = new AIService(this.token);
	},
	provide() {
		return {
			aiService: () => this.aiService
		};
	},
	computed: {
		...mapState(STORE_USER_NAME, {
			token: STATE_TOKEN
		})
	},
	watch: {
		pagination: {
			immediate: false,
			async handler() {
				this.loading = true;
				const data = await this.aiService.getAllJobs('descending', this.pagination.page);

				this.totalElements = data.totalElements;
				this.totalPages = data.totalPages;
				this.jobs = data.elements;

				this.loading = false;
			},
			deep: true
		}
	},
	methods: {
		canShowJobActionsMenu(status) {
			return status === aiActionsStatus.COMPLETE;
		}
	}
};
</script>
